module.exports = __webpack_public_path__ + "img/for-you04.cf8b5b64.jpg";